import ModalHeaderPrimaryVariant from 'components/Modal/partials/ModalHeaderPrimaryVariant.component';
import withConnectedModal from 'components/Modal/withConnectedModal';
import { modifySizeOtpModal } from 'components/OtpModal/OtpModal.helpers';
import OtpContractModalBody from './OtpContractModalBody.component';

export default withConnectedModal({
  showOnMount: true,
  hideOnUnmount: true,
  modalName: 'OtpContractModal',
  headerComponent: ModalHeaderPrimaryVariant,
  bodyComponent: OtpContractModalBody,
  modifyTheme: modifySizeOtpModal,
});
